/**
 * Equalise product-card title heights per grid row.
 * Runs on load, resize, and DOM changes (for dynamically loaded recommendations).
 */
(function () {
  function groupByRow(cards) {
    const rows = [];
    let currentRow = [];
    let currentTop = null;
    cards.forEach(function (card) {
      const top = Math.round(card.getBoundingClientRect().top);
      if (currentTop === null || Math.abs(top - currentTop) < 4) {
        currentRow.push(card);
        if (currentTop === null) currentTop = top;
      } else {
        rows.push(currentRow);
        currentRow = [card];
        currentTop = top;
      }
    });
    if (currentRow.length) rows.push(currentRow);
    return rows;
  }

  function equalize() {
    const scopes = document.querySelectorAll(
      '.vv-recommendations-grid, .collection-product-list, .popular-products__wrapper, .products-slider__container, .product-list, .product-grid'
    );
    scopes.forEach(function (scope) {
      const cards = Array.from(scope.querySelectorAll('.product-card, .collection-product-card'));
      if (cards.length < 2) return;

      // Reset any previously-set min-height before measuring
      cards.forEach(function (card) {
        const title = card.querySelector('.card__title');
        if (title) title.style.minHeight = '';
      });

      // Group by row (by top position)
      const rows = groupByRow(cards);
      rows.forEach(function (row) {
        if (row.length < 2) return;
        let maxH = 0;
        row.forEach(function (card) {
          const title = card.querySelector('.card__title');
          if (title) maxH = Math.max(maxH, title.offsetHeight);
        });
        if (maxH > 0) {
          row.forEach(function (card) {
            const title = card.querySelector('.card__title');
            if (title) title.style.minHeight = maxH + 'px';
          });
        }
      });
    });
  }

  let debounceTimer;
  function scheduleEqualize() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(equalize, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(equalize, 100);
    });
  } else {
    setTimeout(equalize, 100);
  }

  window.addEventListener('resize', scheduleEqualize);
  window.addEventListener('load', function () {
    setTimeout(equalize, 200);
  });

  // Watch for section reloads (Shopify editor / AJAX recommendations)
  document.addEventListener('shopify:section:load', scheduleEqualize);

  // Watch for DOM changes (recommendations load async)
  const observer = new MutationObserver(function (mutations) {
    for (let i = 0; i < mutations.length; i++) {
      const m = mutations[i];
      if (m.addedNodes && m.addedNodes.length) {
        for (let j = 0; j < m.addedNodes.length; j++) {
          const node = m.addedNodes[j];
          if (node.nodeType === 1 && (node.classList?.contains('product-card') || node.querySelector?.('.product-card, .collection-product-card'))) {
            scheduleEqualize();
            return;
          }
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
